import { createFileRoute } from '@tanstack/react-router';

import { ensureDigitalTwinsQueryData } from '@/features/estate-media/api/get-digital-twins';

export const Route = createFileRoute(
  '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/digital-twins'
)({
  loader: ensureDigitalTwinsQueryData,
});
